import {
  Box,
  Divider,
  Flex,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
  useSteps
} from "@chakra-ui/react";
import HeadingSS from "App/BsesPoc/components/common/Heading/HeadingSS";
import ProgressStepper from "App/BsesPoc/components/common/ProgressStepper/ProgressStepper";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import { useContext, useEffect, useState } from "react";
import WorkFlowForm from "../forms/WorkFlowForm";
import { AppContext } from "AppProvider/AppContext";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  showError: boolean;
  loading: boolean;
  setShowError: any;
  submitForm: any;
  initialValues: any;
  type?: string;
  setDeletedApproavals?: any;
};

const steps = [
  { title: "Workflow Features" },
  { title: "Users" },
  { title: "Notification" },
  { title: "Approval Modal" },
  { title: "Table" },
  { title: "Filters" },
  { title: "Triggers" },
  { title: "Others" },
];

export default function WorkFlowFormModal({
  type,
  isOpen,
  onClose,
  showError,
  loading,
  setShowError,
  submitForm,
  initialValues,
  setDeletedApproavals,
}: ModalProps): JSX.Element {
  const { workflowProcess } = useContext(AppContext)
  const isMobileView = useBreakpointValue({ base: true, lg: false });
  const [disabledSteps, setDisabledSteps] = useState([0]);
  // const viewerWidth = useBreakpointValue({ lg: true });
  let width = "97vw";
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length
  });

  console.log('the initialValues are', initialValues)

  useEffect(() => {
    if (type === "edit" || type === "View") {
      setDisabledSteps([0, 1, 2, 3, 4, 5, 6, 7]);
    }
  }, [type]);

  const handleCloseModal = () => {
    setActiveStep(0);
    setDisabledSteps([0]);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleCloseModal} size="full" isCentered>
        <ModalOverlay />
        <ModalContent
          position="fixed"
          right={isOpen ? "0" : `-${width}`}
          top="0"
          height="100vh"
          width={!isMobileView ? width : "100vw"}
          animation={`${isOpen ? "slideIn" : "slideOut"
            } 0.8s ease-in-out forwards`}
        >
          <ModalHeader
            fontSize={{ base: "1rem", md: "1.6rem" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem .6rem"
            ml="1rem"
            textTransform="capitalize"
          >
            {type} WorkFlow
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Grid
              //   minH={"70vh"}
              h="80vH"
              // bg={useColorModeValue("gray.50", "gray.800")}
              templateColumns={{ base: "1fr", lg: "5fr .8fr" }}
              px={{ base: 2, md: 4 }}
              py={0}
              gap={4}
            >
              {isMobileView && (
                <Flex justifySelf="center">
                  <ProgressStepper
                    activeStep={activeStep}
                    steps={steps}
                    orientation={"horizontal"}
                    setActiveStep={setActiveStep}
                    disabledSteps={disabledSteps}
                  />
                </Flex>
              )}
              <ShadowBox>
                <HeadingSS
                  fontSize="lg"
                  headingSS={steps[activeStep].title}
                  ml={2}
                  mb={2}
                />
                <Divider />
                <Box
                  overflow="hidden auto"
                  className="customScrollBar"
                  h={{ base: "70vh", lg: "78vH" }}
                  w="100%"
                  maxW={{ base: "90vw", lg: "78vW" }}
                  // p={2}
                  position="relative"
                >
                  <WorkFlowForm
                    setDeletedApproavals={setDeletedApproavals}
                    type={type}
                    initialVal={initialValues}
                    loading={loading}
                    submitForm={submitForm}
                    showError={showError}
                    setShowError={setShowError}
                    onClose={handleCloseModal}
                    activePage={activeStep}
                    setActiveSteps={setActiveStep}
                    setDisabledSteps={setDisabledSteps}
                    disabledSteps={disabledSteps}
                    steps={steps}
                    workflowProcess={workflowProcess}
                  />
                </Box>
              </ShadowBox>
              {!isMobileView && (
                <ProgressStepper
                  activeStep={activeStep}
                  steps={steps}
                  orientation={"vertical"}
                  setActiveStep={setActiveStep}
                  disabledSteps={disabledSteps}
                />
              )}
            </Grid>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
      </Modal>
    </>
  );
}